import _slicedToArray from "D:\\repos\\finam.portal.onboarding\\NewbiePortal\\newbie_app\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
import { jsx as _jsx } from "react/jsx-runtime";
import { memo, useState, useEffect } from 'react';
import { Typography } from '@finam/web-ui-kit';
import getTimePeriodString from '../../utils/getTimePeriodString';

var CodeLifeTimer = function CodeLifeTimer(_ref) {
  var timeExpire = _ref.timeExpire,
      labelFormat = _ref.labelFormat;

  var _useState = useState(0),
      _useState2 = _slicedToArray(_useState, 2),
      timeLeft = _useState2[0],
      setTimeLeft = _useState2[1];

  useEffect(function () {
    var timeLeftNew = timeExpire - Date.now();

    if (timeLeftNew <= 0) {
      return function () {};
    }

    setTimeLeft(timeLeftNew);
    var intervalId = setInterval(function () {
      var timeLeftNewInterval = timeExpire - Date.now();

      if (timeLeftNewInterval <= 0) {
        clearInterval(intervalId);
      }

      setTimeLeft(timeLeftNewInterval > 0 ? timeLeftNewInterval : 0);
    }, 1000);
    return function () {
      return clearInterval(intervalId);
    };
  }, [timeExpire]);
  return _jsx(Typography, Object.assign({
    variant: "body14",
    color: "secondary"
  }, {
    children: labelFormat(getTimePeriodString(timeLeft))
  }));
};

export default memo(CodeLifeTimer);